/* KAECE · Step 2B · 26.10.26, Step 2C · 26.10.26, panels revised 28.10.26
   1 · Scrolling: clear at the top, slides away going down, returns solid white going up.
   2 · Menu panels: Garments and World open one white panel; the index and the squares answer each other.
   3 · Phone menu: a link with children opens in place, the others fade. */
(function () {
  var root = document.documentElement;
  var desk = window.matchMedia('(min-width: 960px)');
  var hover = window.matchMedia('(hover: hover)');

  /* 2 · Menu panels */
  var items = [].slice.call(document.querySelectorAll('[data-kw]'));
  var dim = null, openT, closeT, current = null, via = '', loaded = false;

  var header = function () { return document.querySelector('.header-container .header') || document.querySelector('.header'); };
  var place = function () {
    var h = header();
    if (h) root.style.setProperty('--kw-top', Math.round(h.getBoundingClientRect().bottom) + 'px');
  };
  var load = function () {
    if (loaded) return;
    loaded = true;
    items.forEach(function (w) {
      [].forEach.call(w.querySelectorAll('img[data-src]'), function (i) {
        i.srcset = i.getAttribute('data-srcset');
        i.src = i.getAttribute('data-src');
      });
    });
  };
  var trig = function (w) { return w.querySelector('[data-kw-trigger]'); };
  var close = function () {
    clearTimeout(openT); clearTimeout(closeT);
    items.forEach(function (w) { w.classList.remove('is-open'); trig(w).setAttribute('aria-expanded', 'false'); });
    root.classList.remove('kw-open');
    current = null; via = '';
  };
  var open = function (w, how) {
    clearTimeout(closeT); clearTimeout(openT);
    if (!desk.matches) return;
    load(); place();
    items.forEach(function (x) { if (x !== w) { x.classList.remove('is-open'); trig(x).setAttribute('aria-expanded', 'false'); } });
    w.classList.add('is-open');
    trig(w).setAttribute('aria-expanded', 'true');
    root.classList.add('kw-open');
    root.classList.remove('kh-hide');
    current = w; via = how || via;
  };

  if (items.length) {
    dim = document.createElement('div');
    dim.className = 'kw-dim';
    document.body.appendChild(dim);
    dim.addEventListener('click', close);

    items.forEach(function (w) {
      var t = trig(w);
      w.addEventListener('mouseenter', function () {
        if (!hover.matches) return;
        clearTimeout(closeT);
        if (current && current !== w) { open(w, 'hover'); return; }
        openT = setTimeout(function () { open(w, 'hover'); }, 120);
      });
      w.addEventListener('mouseleave', function () {
        if (!hover.matches) return;
        clearTimeout(openT);
        closeT = setTimeout(close, 250);
      });
      t.addEventListener('click', function (e) {
        if (!desk.matches) return;
        /* 31.10.26 (Karan): World now has its own page, so Garments and World behave alike: with a mouse, hover opens the panel and a click goes to the page. */
        if (hover.matches || current === w) return;
        e.preventDefault();
        if (current === w && via === 'click') { close(); return; }
        open(w, 'click');
      });
      w.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && current) { close(); t.focus(); }
        if (e.key === 'ArrowDown' && document.activeElement === t) {
          e.preventDefault(); open(w, 'click');
          var first = w.querySelector('[data-kw-link]'); if (first) first.focus();
        }
      });
      w.addEventListener('focusout', function (e) {
        if (!w.contains(e.relatedTarget) && current === w) close();
      });
    });
    /* The index and the squares answer each other (28.10.26):
       Garments: hovering a word shows only its garments (a line, a spec, The System's three), the squares refill in place.
       World: hovering a word or a picture marks the pair; the other words fade, the other pictures dim.
       The word in play is the one at full strength; leaving the panel returns it to its resting state. */
    items.forEach(function (w) {
      var tiles = w.querySelector('[data-kw-tiles]');
      var index = w.querySelector('.kw__index');
      if (!tiles || !index) return;
      var mode = tiles.getAttribute('data-kw-mode') || 'light';
      var rest = index.getAttribute('data-kw-default') || '';
      var words = [].slice.call(index.querySelectorAll('[data-kw-key]'));
      var now = null;
      var has = function (t, key) { return (' ' + (t.getAttribute('data-kw-keys') || '') + ' ').indexOf(' ' + key + ' ') > -1; };
      var light = function (key, quiet) {
        key = key || rest;
        if (key === now) return;
        var first = now === null || quiet;
        now = key;
        words.forEach(function (a) { a.classList.toggle('is-on', !!key && a.getAttribute('data-kw-key') === key); });
        index.classList.toggle('is-picking', !!key && key !== rest);
        var kids = [].slice.call(tiles.children);
        if (mode === 'filter') {
          var show = kids.filter(function (t) { return !key || key === 'all' || has(t, key); });
          if (!show.length) show = kids;
          kids.forEach(function (t) { t.classList.toggle('is-out', show.indexOf(t) < 0); });
          tiles.classList.remove('is-swap');
          if (!first) { void tiles.offsetWidth; tiles.classList.add('is-swap'); }
        } else {
          var hit = 0;
          kids.forEach(function (t) { var on = !!key && has(t, key); t.classList.toggle('is-lit', on); if (on) hit++; });
          tiles.classList.toggle('is-lit', hit > 0);
        }
      };
      words.forEach(function (a) {
        var k = a.getAttribute('data-kw-key');
        a.addEventListener('mouseenter', function () { light(k); });
        a.addEventListener('focus', function () { light(k); });
      });
      if (mode === 'light') {
        [].forEach.call(tiles.children, function (t) {
          var k = (t.getAttribute('data-kw-keys') || '').split(' ')[0];
          t.addEventListener('mouseenter', function () { light(k); });
          var a = t.querySelector('a'); if (a) a.addEventListener('focus', function () { light(k); });
        });
        tiles.addEventListener('mouseleave', function () { light(''); });
        index.addEventListener('mouseleave', function () { light(''); });
      }
      w.addEventListener('mouseleave', function () { light('', true); });
      light('', true);
    });
    if (desk.addEventListener) desk.addEventListener('change', close); else desk.addListener(close);
    var warm = function () { setTimeout(load, 1500); };
    if (document.readyState === 'complete') warm(); else window.addEventListener('load', warm);
  }

  /* 1 · Scrolling */
  var lastY = Math.max(0, window.pageYOffset), ticking = false;
  var onScroll = function () {
    ticking = false;
    var y = Math.max(0, window.pageYOffset);
    root.classList.toggle('kh-solid', y > 10);
    if (y <= 10) { root.classList.remove('kh-hide'); }
    else if (y > lastY + 2 && y > 120) {
      if (current) close();
      if (!document.querySelector('[data-drawer-menu].active')) root.classList.add('kh-hide');
    } else if (y < lastY - 2) { root.classList.remove('kh-hide'); }
    if (current) place();
    lastY = y;
  };
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); }
  }, { passive: true });
  onScroll();

  /* 3 · Phone menu */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-kd-toggle]');
    if (!t) return;
    e.preventDefault();
    var item = t.closest('.kd__item');
    var list = t.closest('.drawer-menu__primary-links');
    var wasOpen = item.classList.contains('is-open');
    [].forEach.call(list.querySelectorAll('.kd__item.is-open'), function (x) {
      x.classList.remove('is-open');
      var a = x.querySelector('[data-kd-toggle]'); if (a) a.setAttribute('aria-expanded', 'false');
    });
    if (!wasOpen) { item.classList.add('is-open'); t.setAttribute('aria-expanded', 'true'); }
    list.classList.toggle('kd-has-open', !wasOpen);
  });
})();
